import React, { useMemo } from "react";

// Hujan konfeti (CSS murni) untuk pesta naik level.
export function Confetti({ count = 46 }) {
  const pieces = useMemo(() => Array.from({ length: count }).map((_, i) => ({
    id: i,
    left: Math.random() * 100,
    delay: Math.random() * 0.9,
    dur: 2.2 + Math.random() * 1.4,
    size: 6 + Math.random() * 7,
    rot: Math.random() * 360,
    color: ["#ff5a5f", "#ffd23f", "#48cae4", "#a5f0c5", "#f78fb3", "#c9a0ff"][i % 6],
    round: i % 3 === 0,
  })), [count]);
  return (
    <div className="pointer-events-none absolute inset-0 z-20 overflow-hidden" data-testid="levelup-confetti">
      {pieces.map((p) => (
        <span key={p.id} className="kk-confetti absolute -top-4"
          style={{
            left: `${p.left}%`, width: p.size, height: p.round ? p.size : p.size * 0.55, background: p.color,
            borderRadius: p.round ? "50%" : 2, transform: `rotate(${p.rot}deg)`,
            animationDelay: `${p.delay}s`, animationDuration: `${p.dur}s`,
          }} />
      ))}
    </div>
  );
}

// Langit malam: bulan sabit + bintang berkelip.
export function NightSky() {
  const stars = useMemo(() => Array.from({ length: 28 }).map((_, i) => ({
    id: i, left: Math.random() * 100, top: Math.random() * 55, size: 1.5 + Math.random() * 2.5, delay: Math.random() * 3,
  })), []);
  return (
    <div className="pointer-events-none absolute inset-0 z-[5] overflow-hidden" data-testid="night-sky">
      {stars.map((s) => (
        <span key={s.id} className="kk-star absolute rounded-full bg-white"
          style={{ left: `${s.left}%`, top: `${s.top}%`, width: s.size, height: s.size, animationDelay: `${s.delay}s` }} />
      ))}
      <div className="absolute right-[12%] top-[14%] h-14 w-14 rounded-full"
        style={{ background: "#fff4c2", boxShadow: "0 0 32px 10px rgba(255,238,170,0.35)" }}>
        <div className="absolute -right-2 -top-2 h-12 w-12 rounded-full" style={{ background: "#1c2340" }} />
      </div>
    </div>
  );
}

export const isNightTime = (d = new Date()) => {
  if (typeof window !== "undefined" && window.location.search.includes("night=1")) return true;
  const h = d.getHours();
  return h >= 18 || h < 5;
};
